import React from "react";
import Section from "./Section";

function Featured() {
  return (
    <Section
      id="popular"
      title="Popular"
      description="Our top selling product that you may like"
    ></Section>
  );
}

export default Featured;
